export default __webpack_public_path__ + "static/media/meh.7e97709e.gif";